export default "__VITE_ASSET__Cwhfl7mk__"